import React from 'react';
import PropTypes from 'prop-types';
import { Container, Headline } from './PageHeader.styles';

const PageHeader = ({ pageTitle, image }) => (
  <Container
    className="page-header page-header_eclips"
    style={{ backgroundImage: `url(${image})` }}
  >
    <Headline className="fs-h1 font-weight-bold page-header__headline">
      {pageTitle}
    </Headline>
    <svg
      style={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}
      viewBox="0 0 1440 93"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M-2 94C180.359 36.8588 437.991 0 721 0C1002.98 0 1259.77 37.2248 1442 94H-2Z"
        fill="#fff"
      />
    </svg>
  </Container>
);

PageHeader.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
};

export default PageHeader;
